









































import { defineComponent, computed, PropType } from '@nuxtjs/composition-api';
import { padStart } from 'lodash-es';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { url } from '~/utils';
import { CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppLink,
  },
  props: {
    contents: {
      type: Array as PropType<{ isRead: Boolean; title: String }[]>,
      required: true,
    },
    lessonId: {
      type: Number,
      required: true,
    },
    articlePage: {
      type: Number,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const selectedContentTitle = computed(() =>
      props.contents
        ? `${padStart(props.articlePage.toString(), 2, '0')}. ${props.contents[props.articlePage - 1].title}`
        : ''
    );

    // 目次のモーダルを閉じる
    const closeDetails = () => {
      const detailsRef = document.getElementById('details-wrapper');
      detailsRef?.removeAttribute('open');
    };
    const { isEnotecaAppWebView } = useEnotecaApp();
    const tag = computed(() => (isEnotecaAppWebView.value ? 'a' : undefined));
    return {
      selectedContentTitle,
      closeDetails,
      url,
      padStart,
      CollegeLessonType,
      tag,
    };
  },
});
